import { createAsyncTypes } from 'utils/ActionCreator'

export const TABS = {
  ENDPOINTS: 'endpoints',
  EVENT_RULES: 'eventRules',
}

export const DRAWER_TYPES = {
  ENDPOINT: 'endpoint',
  EVENT_RULE: 'eventRule',
}

export const DRAWER_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
}

export const STATUS = {
  ACTIVE: 'active',
  DISABLED: 'deactivated',
  ERROR: 'error',
  DRAFT: 'draft',
}

export const NO_EVENT_RULE_WARNING =
  'No event rule selected. Nothing is forwarded to this endpoint until it has an event rule.'

export const ACTIVATE_WITHOUT_RULE_HINT =
  'An endpoint cannot be activated without an event rule. Add one first.'

export const ALL_TENANTS_KEY = '__all__'

export const NAME_MAX_LENGTH = 255

export const FUTURE_EVENT_TYPE_MODE = {
  AUTO: 'auto',
  MANUAL: 'manual',
}

export const DATA_MODEL_VERSION_V2 = 'V2'

export const SET_ACTIVE_TAB = 'Settings/AlertsV2/SET_ACTIVE_TAB'
export const OPEN_DRAWER = 'Settings/AlertsV2/OPEN_DRAWER'
export const CLOSE_DRAWER = 'Settings/AlertsV2/CLOSE_DRAWER'
export const OPEN_DELETE_CONFIRM = 'Settings/AlertsV2/OPEN_DELETE_CONFIRM'
export const CLOSE_DELETE_CONFIRM = 'Settings/AlertsV2/CLOSE_DELETE_CONFIRM'

export const FETCH_ENDPOINTS_ASYNC = createAsyncTypes(
  'FETCH_ENDPOINTS',
  'Settings/AlertsV2/Endpoints'
)
export const FETCH_ENDPOINT_DETAIL_ASYNC = createAsyncTypes(
  'FETCH_ENDPOINT_DETAIL',
  'Settings/AlertsV2/EndpointDetail'
)
export const CREATE_ENDPOINT_ASYNC = createAsyncTypes(
  'CREATE_ENDPOINT',
  'Settings/AlertsV2/Endpoints'
)
export const UPDATE_ENDPOINT_ASYNC = createAsyncTypes(
  'UPDATE_ENDPOINT',
  'Settings/AlertsV2/Endpoints'
)
export const DELETE_ENDPOINT_ASYNC = createAsyncTypes(
  'DELETE_ENDPOINT',
  'Settings/AlertsV2/Endpoints'
)
export const TOGGLE_ENDPOINT_STATUS_ASYNC = createAsyncTypes(
  'TOGGLE_ENDPOINT_STATUS',
  'Settings/AlertsV2/Endpoints'
)

export const OPEN_SETUP_PROMPT = 'Settings/AlertsV2/OPEN_SETUP_PROMPT'
export const CLOSE_SETUP_PROMPT = 'Settings/AlertsV2/CLOSE_SETUP_PROMPT'

export const SHOW_SEF_TOAST = 'Settings/AlertsV2/SHOW_SEF_TOAST'
export const CLEAR_SEF_TOAST = 'Settings/AlertsV2/CLEAR_SEF_TOAST'

export const FETCH_EVENT_RULES_ASYNC = createAsyncTypes(
  'FETCH_EVENT_RULES',
  'Settings/AlertsV2/EventRules'
)
export const CREATE_EVENT_RULE_ASYNC = createAsyncTypes(
  'CREATE_EVENT_RULE',
  'Settings/AlertsV2/EventRules'
)
export const UPDATE_EVENT_RULE_ASYNC = createAsyncTypes(
  'UPDATE_EVENT_RULE',
  'Settings/AlertsV2/EventRules'
)
export const DELETE_EVENT_RULE_ASYNC = createAsyncTypes(
  'DELETE_EVENT_RULE',
  'Settings/AlertsV2/EventRules'
)
export const TOGGLE_EVENT_RULE_STATUS_ASYNC = createAsyncTypes(
  'TOGGLE_EVENT_RULE_STATUS',
  'Settings/AlertsV2/EventRules'
)
export const FETCH_EVENT_RULE_DETAIL_ASYNC = createAsyncTypes(
  'FETCH_EVENT_RULE_DETAIL',
  'Settings/AlertsV2/EventRules'
)
export const FETCH_SCOPE_AUTHORITY_ASYNC = createAsyncTypes(
  'FETCH_SCOPE_AUTHORITY',
  'Settings/AlertsV2/EventRules'
)
export const CLONE_EVENT_RULE_ASYNC = createAsyncTypes(
  'CLONE_EVENT_RULE',
  'Settings/AlertsV2/EventRules'
)

export const ENDPOINT_FORM_SECTIONS = {
  endpoint: [
    {
      id: 'target',
      label: 'Endpoint',
      required: true,
      placeholder: 'https://your-siem.example.com/webhook',
    },
  ],
  authorization: [
    {
      id: 'authMethod',
      label: 'Authorization Method',
      type: 'select',
      options: ['None', 'Custom header', 'Bearer Token'],
    },
    {
      id: 'headerName',
      label: 'Header name',
      required: true,
      placeholder: 'Authorization',
      showWhenAuthMethods: ['Custom header'],
    },
    {
      id: 'headerValue',
      label: 'Header value',
      required: true,
      placeholder: '',
      password: true,
      showWhenAuthMethods: ['Custom header'],
    },
    {
      id: 'token',
      label: 'Token',
      required: true,
      placeholder: 'Enter token',
      hint: "Enter the token only, without 'Bearer'.",
      password: true,
      showWhenAuthMethods: ['Bearer Token'],
    },
  ],
  payload: [
    {
      id: 'format',
      label: 'Payload Format',
      type: 'display',
      value: 'JSON',
    },
  ],
}
